import brandModule from '../scripts/brand/brand.module.js';

import appDependency from '../scripts/appDependency.js';

appDependency.addItem(brandModule);
